<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                   @closeRicerca="closeRicerca"
                   @changeValueOrClick="changeValueOrClick"
                   @remoteMethod="remoteMethod"
                   @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'

  export default {
    name: 'Ricerca',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            stato: 'Stato',
            fornitore: 'Fornitore',
            stabilimento: 'Stabilimento',
            buonoDiScarico: 'Buono di Scarico',
            ricerca: 'Cerca',
            scegli: 'Scegli...',
            filtri: 'Filtri',
            fasciaOraria: 'Fascia oraria',
            tutti: 'Tutti',
            presente: 'Presente',
            assente: 'Assente'
          }
        },
        fr_FR: {
          ricerca: {
            stato: 'Nation',
            fornitore: 'Fournisseur',
            stabilimento: 'Site',
            buonoDiScarico: 'Bon de déchargement',
            ricerca: 'Recherche',
            scegli: 'Choisir...',
            filtri: 'Filtres'
          }
        },
        es_ES: {
          ricerca: {
            stato: 'Estado',
            fornitore: 'Proveedor',
            stabilimento: 'Fabrica',
            buonoDiScarico: 'Vale descarga',
            ricerca: 'Buscar',
            scegli: 'Elegir...',
            filtri: 'Filtros'
          },
        },
        de_DE: {
          ricerca: {
            stato: 'Land',
            fornitore: 'Lieferant',
            stabilimento: 'Werke',
            buonoDiScarico: 'Entladeschein',
            ricerca: 'Suche',
            scegli: 'Wählen...',
            filtri: 'Filter'
          }
        },
        en_GB: {
          ricerca: {
            stato: 'Country',
            fornitore: 'Supplier',
            stabilimento: 'Factory',
            buonoDiScarico: 'Unloading Pass',
            ricerca: 'Search',
            scegli: 'Choose...',
            filtri: 'Filters'
          }
        }
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        firstLoad: true,
        form: {
          country: '1',
          fornitore: {},
          stab: {},
          buonoDiScarico: '',
          ifTSL: {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
        },
        filtriRicerca: {
          loading: false,
          titolo: '',
          valueSelected: {
            0: '',
            1: {},
            2: {},
            3: '',
            4: {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
          },
          dati: {
            0: [],
            1: [],
            2: [],
            4: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con i codici fornitore e spedizioniere
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codForn', 'descForn'],
              key: 'codForn',
              onChangeOrClick: 'changeCodForn',
              ifClearable: false,
              ifDisabled: false,
              ifShow: false
            },
            // Select con gli Stabilimenti
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['descStab'],
              key: 'codStab',
              onChangeOrClick: 'changeStab',
              ifClearable: false,
              ifDisabled: true,
              ifShow: true
            },
            // Campo di input per inserire il numero di Buono di Scarico
            {
              type: 'input',
              myLabel: '',
              ifClearable: true,
              onChangeOrClick: 'changeBuonoDiScarico'
            },
            // Select per filtrare i buoni con slot di scarico impostato o meno
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['desc'],
              key: 'value',
              onChangeOrClick: 'changeIfTSL',
              ifClearable: true,
              ifDisabled: false,
              ifShow: false
            },
          ]
        },
        codForn: '',
        codFornAdmin: {}
      }
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.setTraduzioniLabel()
        this.setIfTSLValues()
        this.$nextTick(() => {
          this.getCountries()
        })
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.filtriRicerca.valueSelected[1] = {}
          this.filtriRicerca.valueSelected[2] = {}
          this.filtriRicerca.valueSelected[3] = ''
          this.filtriRicerca.valueSelected[4] = {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
          this.filtriRicerca.dati[1] = []
          this.filtriRicerca.dati[2] = []
          this.filtriRicerca.dati[4] = []
          this.filtriRicerca.filtri[1].ifDisabled = true
          this.filtriRicerca.filtri[2].ifDisabled = true
          this.$set(this.form, 'fornitore', {})
          this.$set(this.form, 'stab', {})
          this.$set(this.form, 'buonoDiScarico', '')
          if (this.codForn !== '') {
            this.getStabilimenti()
          }
        }
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.filtriRicerca.valueSelected[0] = localStorage.getItem('TRAACQ_country')
      })
    },
    methods: {
      resetDati: function () {
        this.$set(this.form, 'fornitore', {})
        this.$set(this.form, 'stab', {})
        this.$set(this.form, 'buonoDiScarico', '')
        this.$set(this.form, 'ifTSL', '')
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
        }
        this.filtriRicerca.dati[1] = []
        this.filtriRicerca.dati[2] = []
        this.filtriRicerca.dati[4] = []
        // this.$set(this.form, 'country', this.filtriRicerca.valueSelected[0])
        this.filtriRicerca.valueSelected[1] = {}
        this.filtriRicerca.valueSelected[2] = {}
        this.filtriRicerca.valueSelected[3] = ''
        this.filtriRicerca.valueSelected[4] = {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
        this.filtriRicerca.filtri[2].ifDisabled = true
      },
      init: function () {
        this.setIfTSLValues()
        if (sessionStorage.hasOwnProperty('WGR_form')) {
          let form =  JSON.parse(sessionStorage.getItem('WGR_form'))
          this.$set(this, 'form', form)
          this.filtriRicerca.valueSelected[0] = form.country
          this.$set(this, 'codForn', form.fornitore.tipForn + form.fornitore.codForn)
          this.filtriRicerca.valueSelected[1] = form.fornitore
          this.filtriRicerca.valueSelected[2] = form.stab
          this.filtriRicerca.valueSelected[3] = form.buonoDiScarico
          this.filtriRicerca.valueSelected[4] = form.ifTSL ? form.ifTSL : {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
        } else {
          this.filtriRicerca.valueSelected[4] = {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
          this.$set(this.form, 'ifTSL', {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'})
        }
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
        }
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.setTraduzioniLabel()
        this.$nextTick(() => {
          this.getCountries()
        })
      },
      setIfTSLValues: function () {
        this.filtriRicerca.dati[4] = [
          {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'},
          {desc: this.$t('ricerca.presente').toUpperCase(), value: 'Y'},
          {desc: this.$t('ricerca.assente').toUpperCase(), value: 'N'}
        ]
      },
      setTraduzioniLabel: function () {
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.stato'))
        // this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.stabilimento'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.buonoDiScarico'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.fasciaOraria'))
      },
      remoteMethod: function (index, query) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('remoteMethod')) {
          this[this.filtriRicerca.filtri[index].remoteMethod](query)
        }
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      changeValueOrClick: function (index, value) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick](value)
        }
      },
      changeBuonoDiScarico: function () {
        this.$set(this.form, 'buonoDiScarico', this.filtriRicerca.valueSelected[3])
      },
      getCountries: function () {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebGestioneRottame'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[0] = response.body.data
               if (!sessionStorage.hasOwnProperty('WGR_form')) {
                let flag = false
                response.body.data.forEach((obj) => {
                  if (obj.country === localStorage.getItem('TRAACQ_country')) {
                    flag = true
                  }
                })
                if (flag === true) {
                  this.filtriRicerca.valueSelected[0] = localStorage.getItem('TRAACQ_country')
                  this.$set(this.form, 'country', localStorage.getItem('TRAACQ_country'))
                } else {
                  this.filtriRicerca.valueSelected[0] = response.body.data[0].country
                  this.$set(this.form, 'country', response.body.data[0].country)
                }
              }
              this.getFornitoreInfo()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeCountry: function (val) {
        this.$set(this.form, 'fornitore', {})
        this.$set(this.form, 'stab', {})
        this.$set(this.form, 'buonoDiScarico', '')
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
        }
        this.filtriRicerca.dati[1] = []
        this.filtriRicerca.dati[2] = []
        this.$set(this.form, 'country', this.filtriRicerca.valueSelected[0])
        this.filtriRicerca.valueSelected[1] = {}
        this.filtriRicerca.valueSelected[2] = {}
        this.filtriRicerca.valueSelected[3] = ''
        this.filtriRicerca.filtri[2].ifDisabled = true
        sessionStorage.removeItem('TRAACQ_fornitore')
        this.getFornitoreInfo(true)
        this.$emit('changeCountry')
      },
      getFornitoreInfo: function (ifChangeCountry) {
        this.$http.get('buonidiscarico/info', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              if (response.body.attrib.typeOfUser === 'fornitore') {
                // this.filtriRicerca.filtri[1].typeOfUser = 'fornitore'
                this.filtriRicerca.dati[1] = response.body.data
                this.filtriRicerca.filtri[1].ifDisabled = (response.body.data.length <= 1)
                this.filtriRicerca.filtri[1].ifShow = true
                if (!sessionStorage.hasOwnProperty('WGR_form') || ifChangeCountry) {
                  if (sessionStorage.hasOwnProperty('TRAACQ_fornitore')) {
                    let TRAACQ_fornitore = sessionStorage.getItem('TRAACQ_fornitore')
                    let flag = false
                    response.body.data.forEach((forn) => {
                      if ((forn.tipForn + forn.codForn) === (TRAACQ_fornitore)) {
                        flag = true
                        this.filtriRicerca.valueSelected[1] = forn
                        this.$set(this.form, 'fornitore', forn)
                        this.$set(this, 'codForn', forn.tipForn + forn.codForn)
                      }
                    })
                    if (flag === false) {
                      this.filtriRicerca.valueSelected[1] = response.body.data[0]
                      this.$set(this.form, 'fornitore', response.body.data[0])
                      this.$set(this, 'codForn', response.body.data[0].tipForn + response.body.data[0].codForn)
                    }
                  } else {
                    this.filtriRicerca.valueSelected[1] = response.body.data[0]
                    this.$set(this.form, 'fornitore', response.body.data[0])
                    this.$set(this, 'codForn', response.body.data[0].tipForn + response.body.data[0].codForn)
                  }
                }

                this.getStabilimenti()
              } else if (response.body.attrib.typeOfUser === 'admin') {
                // this.filtriRicerca.filtri[1].typeOfUser = 'admin'
                if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]] !== '') {
                  this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
                }
                this.filtriRicerca.filtri[1].ifShow = false
                if (this.codForn !== '') {
                  // this.getListFornAdm(this.form.fornitore.codForn)
                  this.getStabilimenti()
                } else {
                  this.$emit('stopLoading')
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeCodForn: function () {
        this.$set(this.form, 'fornitore', this.filtriRicerca.valueSelected[1])
        this.$set(this, 'codForn', this.filtriRicerca.valueSelected[1].tipForn + this.filtriRicerca.valueSelected[1].codForn)
        this.$set(this.form, 'stab', {})
        this.filtriRicerca.dati[2] = []
        this.filtriRicerca.filtri[2].ifDisabled = true
        this.filtriRicerca.valueSelected[2] = {}
        this.getStabilimenti()
      },
      getStabilimenti: function () {
        this.$http.get('buonidiscarico/stabilimenti', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[2] = response.body.data
              if (response.body.data.length > 0) {
                if (JSON.stringify(this.form.stab) === '{}') {
                  this.$set(this.form, 'stab', response.body.data[0])
                  this.filtriRicerca.valueSelected[2] = response.body.data[0]
                  if (!sessionStorage.hasOwnProperty('WGR_form') && this.filtriRicerca.dati[2].length === 1) {
                    this.cerca()
                  }
                }
                this.filtriRicerca.filtri[2].ifDisabled = false
                // Mostro la select ifTSL solo se sono nella pagina dei buoni
                this.$set(this.filtriRicerca.filtri[4], 'ifShow', (this.$route.path.indexOf('/rottame/gestionerottame/buoni') >= 0 && this.filtriRicerca.valueSelected[2].ROT_SLOT_RULES === 'Y'))
                if (this.$route.path.indexOf('/rottame/gestionerottame/buoni') < 0 || this.filtriRicerca.valueSelected[2].ROT_SLOT_RULES === 'N') {
                  this.filtriRicerca.valueSelected[4] = {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
                  this.$set(this.form, 'ifTSL', {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'})
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeStab: function () {
        this.filtriRicerca.dati[2].forEach((item) => {
          if (item.codStab === this.filtriRicerca.valueSelected[2].codStab) {
            this.$set(this.form, 'stab', item)
          }
        })
        // Mostro la select ifTSL solo se sono nella pagina dei buoni
        this.$set(this.filtriRicerca.filtri[4], 'ifShow', (this.$route.path.indexOf('/rottame/gestionerottame/buoni') >= 0 && this.filtriRicerca.valueSelected[2].ROT_SLOT_RULES === 'Y'))
        if (this.$route.path.indexOf('/rottame/gestionerottame/buoni') < 0 || this.filtriRicerca.valueSelected[2].ROT_SLOT_RULES === 'N') {
          this.filtriRicerca.valueSelected[4] = {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
          this.$set(this.form, 'ifTSL', {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'})
        }
      },
      changeIfTSL: function () {
        this.filtriRicerca.dati[4].forEach((item) => {
          if (item.value === this.filtriRicerca.valueSelected[4].value) {
            this.$set(this.form, 'ifTSL', item)
          }
        })
      },
      cerca: function () {
        let oldForm = JSON.parse(sessionStorage.getItem('WGR_form'))
        console.log(oldForm)
        if (oldForm && (oldForm.country !== this.form.country || oldForm.stab.codSoc !== this.form.stab.codSoc || oldForm.stab.codStab !== this.form.stab.codStab)) {
          this.$router.push({name: 'GestioneRottameConferme'})
          this.$nextTick(() => {
            this.$emit('ricerca', JSON.stringify(this.form))
          })
        }

        let fornitore = {
          codForn: this.codForn.substring(1),
          tipForn: this.codForn.substring(0, 1)
        }
        this.$set(this.form, 'fornitore', fornitore)
        sessionStorage.setItem('WGR_form', JSON.stringify(this.form))
        if (sessionStorage.getItem('TRAACQ_fornitore') !== this.codForn) {
          sessionStorage.setItem('TRAACQ_fornitore', this.codForn)
          bus.$emit('TRAACQ_ChangeCountryFromApp')
        }

        if (!this.form.buonoDiScarico) {
          /*
          if (this.$route.path.indexOf('/rottame/gestionerottame/conferme') < 0) {
            this.$router.push({name: 'GestioneRottameConferme'})
          }
          */
          this.$nextTick(() => {
            this.$emit('ricerca', JSON.stringify(this.form))
          })
        } else {
          if (this.$route.path.indexOf('/rottame/gestionerottame/buoni') < 0) {
            this.$router.push({name: 'GestioneRottameElencoBuoni'})
          }
        }
        this.closeRicerca()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/Ricerca.vue